import React from 'react';
import {get} from 'lodash';

// only for NEOU netflix tray
export function displayDetailsOnBottom(duration, gist){
    const category = gist.primaryCategory;
    const concept = gist.featuredTag ? gist.featuredTag.title : "";
    const durationFromRuntime = `${parseInt((gist.runtime+1)/60)}m`;

    return <div className="details_bottom">
    <div className="black_bar">
      {`${duration ? duration.title : durationFromRuntime}${category ? " · " + category.title : ""}`} 
    </div>
    <div className="black_bar">
      {`${concept ? concept + " ·" : ""} ${gist.title}`}
    </div>
  </div>
}

export function displayCategoryItems(item, onlyPrimary){
  let categories = [];
  item.gist.primaryCategory && categories.push(item.gist.primaryCategory.title);
  if(!onlyPrimary && item.categories){
    let secondaryCategory = item.categories.map(e => e.title);
    categories = categories.concat(secondaryCategory)
  }
  return categories;
}

export function getThumbnailImage(props) {
  var w = props.maxWidth || 400;
  var gist = props.item.gist;
  var url =
    props.thumbnailType === "portrait"
      ? gist.posterImageUrl ||
        get(gist.posterImage, "url") ||
        get(props.item.images, "_3x4Image.secureUrl") ||
        get(props.item.gist, 'imageGist["_3x4"]') ||
        get(window.settings, "images.placeholderPoster")
      : gist.videoImageUrl ||
        get(gist.videoImage, "url") ||
        get(gist, "landscapeImageUrl") ||
        get(props.item.images, "_16x9Image.secureUrl") ||
        get(props.item.gist, 'imageGist["_16x9"]') ||
        get(props.item.images, "_16x9.url") ||
        get(window.settings, "images.placeholderCover");
  if (props.thumbnailType === "portrait") {
    return `${url}?impolicy=resize&w=${w}&h=${w * 1.48}`;
  } else {
    return `${url}?impolicy=resize&w=${w}&h=${w * 0.5625}`;
  }
}

export function getLowQualityImage(props) {
  var gist = props.item.gist;
  var url =
    props.thumbnailType === "portrait"
      ? gist.posterImageUrl ||
        get(gist.posterImage, "url") ||
        get(window.settings, "images.placeholderPoster")
      : gist.videoImageUrl ||
        get(gist.videoImage, "url") ||
        get(gist, "landscapeImageUrl") ||
        get(props.item.images, "_16x9.url") ||
        get(window.settings, "images.placeholderCover");
  return `${url}?impolicy=resize&w=20&h=20`;
}

export function trayHoverStyle(trayGlowColor){
  return {
    boxShadow: `0px 0px 34px 0px ${trayGlowColor}`
  }
}